module.exports = __webpack_public_path__ + "static/media/transpak_example1.765c73c3.png";